function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "11.-E---apm\\u0101c\\u012Bba---Uzdot-jaut\\u0101jumu-pasniedz\\u0113jam",
  transform: "translate(-737.000000, -259.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Popup",
  transform: "translate(516.000000, 194.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(48.000000, 48.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(156.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.000000, 17.000000)",
  id: "icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.68146504,9.68145161 C5.68146504,8.80331541 5.78209397,8.10394265 5.98335183,7.58333333 C6.18460969,7.06272401 6.55308916,6.5499552 7.08879023,6.04502688 C7.62449131,5.54009857 7.98113208,5.12925627 8.15871254,4.8125 C8.33629301,4.49574373 8.42508324,4.16173835 8.42508324,3.81048387 C8.42508324,2.75044803 7.96337403,2.22043011 7.0399556,2.22043011 C6.60192379,2.22043011 6.25120237,2.36312724 5.98779134,2.64852151 C5.72438032,2.93391577 5.58675546,3.32750896 5.57491676,3.82930108 L3,3.82930108 C3.0118387,2.6312724 3.37735849,1.69354839 4.09655938,1.01612903 C4.81576027,0.338709677 5.79689234,1.13686838e-13 7.0399556,1.13686838e-13 C8.29485757,1.13686838e-13 9.26859046,0.321460573 9.96115427,0.96438172 C10.6537181,1.60730287 11,2.51523297 11,3.68817204 C11,4.22132616 10.8875324,4.72468638 10.6625971,5.19825269 C10.4376619,5.671819 10.0440252,6.19713262 9.48168701,6.77419355 L8.76248613,7.49865591 C8.31261561,7.95654122 8.05512394,8.49283154 7.9900111,9.10752688 L7.95449501,9.68145161 L5.68146504,9.68145161 Z M5.42397336,12.5698925 C5.42397336,12.1496416 5.55863855,11.8030914 5.82796892,11.5302419 C6.0972993,11.2573925 6.44210137,11.1209677 6.86237514,11.1209677 C7.28264891,11.1209677 7.62745098,11.2573925 7.89678135,11.5302419 C8.16611173,11.8030914 8.30077691,12.1496416 8.30077691,12.5698925 C8.30077691,12.983871 8.1690714,13.3257168 7.90566038,13.5954301 C7.64224935,13.8651434 7.29448761,14 6.86237514,14 C6.43026267,14 6.08250092,13.8651434 5.8190899,13.5954301 C5.55567888,13.3257168 5.42397336,12.983871 5.42397336,12.5698925 Z"
})))))));

function SvgIcAskQuestionNoBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "60E4F544-8CBB-49C6-9975-BBF71275C742") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAskQuestionNoBg);
export default __webpack_public_path__ + "static/media/ic-ask-question-no-bg.94627d9c.svg";
export { ForwardRef as ReactComponent };